import React from 'react';
import { motion } from 'framer-motion';
import { Section, fadeInUp, staggerContainer } from './ui/Section';
import { Check } from 'lucide-react';
export function WhatYouGet() {
  return <Section id="what-you-get" data-id="element-134">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={staggerContainer} className="max-w-5xl mx-auto" data-id="element-135">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-136">
          <motion.div variants={fadeInUp} data-id="element-137">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-8" data-id="element-138">
              Lo Que <span className="text-gold-gradient" data-id="element-139">Obtienes</span>
            </h2>

            <div className="space-y-6" data-id="element-140">
              {['Una faja colombiana original (talla 2XL a 5XL a tu medida).', 'Un eBook digital con toda la guía de uso, ajuste y cuidado de la faja colombiana.', 'Una asesoría personalizada 1:1 para resolver todas tus dudas.'].map((item, index) => <div key={index} className="flex items-start gap-4 bg-dark-900 p-4 rounded-xl border border-gold-dark/10" data-id="element-141">
                  <div className="bg-gold-DEFAULT rounded-full p-1 mt-1 flex-shrink-0" data-id="element-142">
                    <Check className="w-4 h-4 text-dark-900 stroke-[3]" data-id="element-143" />
                  </div>
                  <span className="text-xl text-gray-200" data-id="element-144">{item}</span>
                </div>)}
            </div>
          </motion.div>

          <motion.div variants={fadeInUp} className="relative" data-id="element-145">
            <div className="absolute inset-0 bg-gold-gradient opacity-20 blur-[100px] rounded-full" data-id="element-146"></div>
            <div className="relative bg-dark-900 border border-gold-dark/30 p-8 rounded-2xl text-center" data-id="element-147">
              <div className="inline-block bg-red-600 text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4" data-id="element-148">
                🔥 Solo por hoy
              </div>
              <h3 className="text-2xl font-serif text-white mb-4" data-id="element-149">
                Paquete Súper Exclusivo
              </h3>
              <div className="mb-2" data-id="element-150">
                <span className="text-2xl text-gray-500 line-through" data-id="element-151">
                  $240
                </span>
              </div>
              <div className="text-6xl font-bold text-gold-gradient mb-1" data-id="element-152">
                $68
              </div>
              <p className="text-gold-light text-sm font-semibold mb-6" data-id="element-153">
                ¡Ahorras $172 hoy!
              </p>
              <p className="text-gray-400 mb-8" data-id="element-154">
                Oferta disponible por tiempo limitado
              </p>

              <div className="space-y-4" data-id="element-155">
                <div className="flex justify-between text-gray-400 border-b border-gray-800 pb-2" data-id="element-156">
                  <span data-id="element-157">Faja Colombiana Original</span>
                  <span className="text-white" data-id="element-158">Incluido</span>
                </div>
                <div className="flex justify-between text-gray-400 border-b border-gray-800 pb-2" data-id="element-159">
                  <span data-id="element-160">eBook Guía de Uso</span>
                  <span className="text-white" data-id="element-161">Incluido</span>
                </div>
                <div className="flex justify-between text-gray-400 border-b border-gray-800 pb-2" data-id="element-162">
                  <span data-id="element-163">Asesoría 1-a-1</span>
                  <span className="text-white" data-id="element-164">Incluido</span>
                </div>
                <div className="flex justify-between text-gray-400 pt-2" data-id="element-165">
                  <span data-id="element-166">Envío a EE.UU.</span>
                  <span className="text-gold-DEFAULT font-bold" data-id="element-167">GRATIS</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </Section>;
}